import {Component, OnDestroy, OnInit} from '@angular/core';
import {PagamentosEletronicosService} from '../../../services/pagamentos-eletronicos.service';
import {
  rotuloStatusFinanceiroConnectTef,
  rotuloStatusFiscalConnectTef,
} from '../../../pedidos/pagamentos-eletronicos/pagamentos-eletronicos-apresentacao';

@Component({
  selector: 'app-transacoes-connecttef',
  templateUrl: './transacoes-connecttef.component.html',
  styleUrls: ['./transacoes-connecttef.component.scss']
})
export class TransacoesConnectTefComponent implements OnInit, OnDestroy {
  readonly rotuloStatusFinanceiro = rotuloStatusFinanceiroConnectTef;
  readonly rotuloStatusFiscal = rotuloStatusFiscalConnectTef;
  pendencias: any[] = [];
  filtroTipo = '';
  filtroStatus = '';
  carregando = false;
  erro: string;
  mensagem: string;
  private atualizacao: any;

  constructor(private pagamentosEletronicosService: PagamentosEletronicosService) {}

  ngOnInit() {
    this.carregue();
    this.atualizacao = window.setInterval(() => this.carregue(false), 30000);
  }

  ngOnDestroy() {
    if(this.atualizacao) window.clearInterval(this.atualizacao);
  }

  async carregue(exibaCarregamento = true) {
    if(exibaCarregamento) this.carregando = true;
    this.erro = null;
    try {
      const pendencias = await this.pagamentosEletronicosService.listePendenciasConnectTef();
      const resolucoes = new Map(this.pendencias
        .filter(item => !!item.identificacao && !!item.resolucao)
        .map(item => [item.identificacao, item.resolucao]));
      this.pendencias = (pendencias || []).map(item => Object.assign(item, {
        resolucao: resolucoes.get(item.identificacao) || item.resolucao ||
          {acao: this.acaoPadrao(item), justificativa: '', evidencia: ''},
      }));
    } catch(erro) {
      this.erro = this.mensagemErro(erro);
    } finally {
      this.carregando = false;
    }
  }

  get pendenciasFiltradas() {
    return this.pendencias.filter(item =>
      (!this.filtroTipo || (item.tipos || [item.tipo]).indexOf(this.filtroTipo) !== -1) &&
      (!this.filtroStatus || item.statusFinanceiro === this.filtroStatus)
    );
  }

  podeResolver(item: any) {
    return !!item && !!item.identificacao && (
      item.statusFinanceiro === 'INDETERMINATE' || item.posProcessamentoPendente ||
      item.statusFiscal === 'BLOCKED_ACQUIRER_MAPPING' || item.statusFiscal === 'FISCAL_ERROR'
    );
  }

  async resolva(item: any) {
    this.erro = null;
    this.mensagem = null;
    if(!item.resolucao.justificativa || !item.resolucao.evidencia) {
      this.erro = 'Informe a justificativa e a evidência externa da resolução.';
      return;
    }
    item.resolvendo = true;
    try {
      await this.pagamentosEletronicosService.resolvaPendenciaConnectTef(
        item.identificacao, item.resolucao
      );
      this.mensagem = 'Resolução registrada e auditada.';
      await this.carregue(false);
    } catch(erro) {
      this.erro = this.mensagemErro(erro);
    } finally {
      item.resolvendo = false;
    }
  }

  rotuloTipo(tipo: string) {
    return ({
      TRANSACAO_INDETERMINADA: 'Resultado indeterminado',
      POS_PROCESSAMENTO_PENDENTE: 'Pós-processamento pendente',
      CALLBACK_CONFLITANTE: 'Callback conflitante',
      BLOQUEIO_FISCAL_ADQUIRENTE: 'Adquirente sem mapeamento fiscal',
      ESTORNO_PENDENTE: 'Estorno pendente',
      FATURAMENTO_TERMINAIS: 'Divergência de faturamento',
    } as any)[tipo] || tipo;
  }

  classePendencia(item: any) {
    const tipos = item && (item.tipos || [item.tipo]) || [];
    if(tipos.indexOf('CALLBACK_CONFLITANTE') !== -1 || tipos.indexOf('TRANSACAO_INDETERMINADA') !== -1)
      return 'is-critical';
    if(tipos.indexOf('ESTORNO_PENDENTE') !== -1 || tipos.indexOf('BLOQUEIO_FISCAL_ADQUIRENTE') !== -1)
      return 'is-warning';
    return 'is-info';
  }

  iconePendencia(item: any) {
    const classe = this.classePendencia(item);
    if(classe === 'is-critical') return 'fa-exclamation-triangle';
    if(classe === 'is-warning') return 'fa-clock';
    return 'fa-sync';
  }

  private acaoPadrao(item: any) {
    return item && item.statusFinanceiro === 'INDETERMINATE' ? 'REJEITAR' : 'REPROCESSAR';
  }

  private mensagemErro(erro: any) {
    return String(erro && erro.erro || erro && erro.message || erro || 'Falha ao consultar a fila ConnectTEF.');
  }
}
